import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './wrike-folder.types';
import * as constants from './wrike-folder.constants';

export const wrikeFolderReducer = generateResourceReducer<types.IWrikeFolder>({
  STORE: constants.STORE_WRIKE_FOLDER,
  CLEAR: constants.CLEAR_WRIKE_FOLDER,
});
